module.exports = __webpack_public_path__ + "img/hina-logo.6000be1b.png";